import { useGetCurrentUserFavorites } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { useSelector } from 'react-redux';
import Favorite from './Favorite/Favorite';
import styles from './styles.module.scss';

const FavoriteList = () => {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const { data: favorites } = useGetCurrentUserFavorites();
  const favoritesForSelectedChannel =
    favorites?.favorites.filter((favorite) => favorite.channelId === selectedChannelId) ?? [];

  return (
    <div className={styles.favoriteList}>
      <div className={styles.favoriteTitle}>Favoriten</div>
      <div className={styles.favoritesContent}>
        {favoritesForSelectedChannel.map((favorite) => (
          <Favorite key={favorite.id} favorite={favorite} />
        ))}
      </div>
    </div>
  );
};

export default FavoriteList;
